<template>
<div :class="`liveshopping-settings ${!liveshoppingEnabled ? 'centerize' : ''}`">
  <template v-if="liveshoppingEnabled">
    <h2 class="integrations-title">{{ shoppingSettings.provider === '' && provider.selected === '' ? $t('settings.liveshopping.integrations') : $t('settings.liveshopping.integration') }}</h2>
    <p class="m-b-4" v-if="shoppingSettings.provider === '' && provider.selected === ''">{{ $t('settings.liveshopping.select_integration') }} You can change provider at any time.
    </p>
    <div class="providers" :class="`${provider.selected !== '' ? 'providers--full' : ''}`" :key="providerKey">
      <card-minimal class="provider" v-for="prov in $options.providers" :key="prov.id" :class="`${provider.selected === prov.id ? 'provider--active' : ''}`" v-if="(prov.saveable && !prov.hiddenForOutsiders) || (prov.saveable && isSuperUser) || (prov.saveable && (user.account_id === 4741 || user.account_id === 4685))">
        <template slot="header">
          <div class="provider-logo"><img :src="require(`@/assets/${prov.id}-logo.svg`)" /></div>
          <div class="provider-description">
            <p v-if="shoppingSettings.provider !== prov.id">{{ $t(`settings.liveshopping.${prov.id}_description`) }}</p>
            <template v-else>
              <i class="mdi mdi-check-circle color-success"></i>
              <p v-html="$t(`settings.liveshopping.${prov.id}_connected_text`)"></p>
            </template>
          </div>
        </template>
        <div class="p-a-4 d-f ai-c jc-c rounded-bottom" slot="footerButton" @click.prevent="provider.selected = prov.id" tabindex="0" v-if="provider.selected === ''">
          <span class="t-c">{{ prov.manual ? 'Manual' : $t('settings.liveshopping.connect') }} {{ prov.name }}</span>
        </div>
        <div class="p-a-4" v-if="provider.selected === prov.id">
          <div class="provider-row">
            <div class="inputs f-w">
              <div class="d-f f-g-16 f-wrap">
                <div v-for="(field, index) in $options.providers[providerIndex].data" :key="index" :class="`${field.class}`">
                  <label class="dark m-b-1">{{ $t(`settings.liveshopping.${provider.selected}_${field.label}`) }}</label>
                  <FormInput
                    type="text"
                    @input="updateProviderDataKey"
                    v-model="provider.data[field.write]"
                    :outline="true"
                    :class="`${index === 0 && shoppingSettings.provider === provider.selected ? '' : ''}`"
                    :disabled="field.disable && shoppingSettings.provider === provider.selected"
                    :placeholder="$t(`settings.liveshopping.${prov.id}_${field.placeholder}`)"
                    :tooltip="!!field.tooltip"
                    :tooltipText="field.tooltip"
                  />
                  <template v-if="shoppingSettings.provider && prov.refresh && index === 0">
                    <a :class="`link blue i-b m-t-2 ${shoppingSettings.metadata.status === 'feed_parsing' ? 'disable' : ''}`" @click="refreshProvider">
                      <template v-if="state.refresh === 'refreshing'">Refreshing feed..</template>
                      <template v-if="state.refresh === 'refreshed'">Feed refreshed</template>
                      <template v-if="state.refresh === ''">Refresh feed</template>
                    </a>
                  </template>
                  <template v-if="shoppingSettings.provider !== 'shopify' && shoppingSettings.provider !== 'shopline' && shoppingSettings.metadata.refreshed_at">
                    <small class="m-l-2">Refreshed at {{ shoppingSettings.metadata.refreshed_at | formatdate }}</small>
                  </template>
                  <div v-if="['feed_indexed', 'feed_received', 'feed_parsing', 'feed_parsing_error', 'feed_parsed', 'feed_parsed_error', 'feed_indexing', 'feed_indexing_error', 'feed_indexed_error'].includes(shoppingSettings.metadata.status)">
                    <p>Status: {{ shoppingSettings.metadata.status.replace('_', ' ') }}</p>
                  </div>
                </div>
              </div>
              <div class="f-w">
                <template v-if="$options.providers[providerIndex].advancedFields">
                  <div class="advanced p-y-2 f-w">
                    <a class="link blue" @click="showAdvanced = !showAdvanced">{{ showAdvanced ? $t('common.hide') : $t('common.show') }} {{ $t('settings.liveshopping.advanced_settings') }} &raquo;</a>
                    <div class="p-y-2 f-w d-f f-wrap f-g-8" v-if="showAdvanced">
                      <div v-for="(field, index) in $options.providers[providerIndex].advancedFields.data" :key="index" class="f-1">
                        <label class="dark m-b-1">{{ $t(`settings.liveshopping.${provider.selected}_${field.label}`) }}</label>
                        <FormInput type="text" @input="updateProviderDataKey" v-model="provider.data[field.write]" :tooltip="!!field.tooltip" :tooltipText="$t(`settings.liveshopping.${provider.selected}_${field.write}_tooltip`)" :outline="true" :class="`${field.class}`" :placeholder="$t(`settings.liveshopping.${provider.selected}_${field.placeholder}`)" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="buttons d-f jc-fe">
              <template v-if="shoppingSettings.provider">
                <template v-if="providerDataChanged">
                  <Button :icon="state.provider === 'saving' ? 'loading mdi-spin' : null" :class="`${state.provider !== '' ? 'very-blue-light' : 'very-blue'}`" @click="saveProvider()">{{ $t(`common.${state.provider !== '' ? 'updating' : 'update'}`) }}</Button>
                  <Button class="m-l-2 only-text keep-hover blue" @click="cancelProviderUpdate()">{{ $t('common.cancel') }}</Button>
                </template>
                <template v-else>
                  <Button class="very-blue-border m-r-2" @click="testfeed = true" v-if="!prov.manual">{{ $t('settings.liveshopping.test_integration') }}</Button>
                  <Button class="red only-text keep-hover" v-if="shoppingSettings.provider === prov.id" @click="disconnectProvider()">{{ $t('settings.liveshopping.disconnect') }}</Button>
                </template>
              </template>
              <template v-else>
                <Button :icon="state.provider === 'saving' ? 'loading mdi-spin' : null" :class="`${!validateFeed || state.provider !== '' ? 'very-blue-light' : 'very-blue'}`" :disabled="!validateFeed || state.provider !== ''" @click="validateFeed ? saveProvider() : null" style="white-space: nowrap">
                  {{ $t(`settings.liveshopping.${state.provider !== '' ? prov.buttonFlightText : prov.buttonText}`) }}
                </Button>
                <Button class="m-l-2 outline" @click="cancelProvider()">{{ $t('common.cancel') }}</Button>
              </template>
            </div>
          </div>
        </div>
      </card-minimal>
    </div>

    <template v-if="done && shoppingSettings.provider !== ''">
      <card-minimal :title="$t('settings.liveshopping.active_domains')" class="m-t-4">
        <template slot="header">
          <div class="p-a-4">
            <h2>{{ $t('settings.liveshopping.active_domains_title') }}</h2>
          </div>
        </template>
        <div class="p-a-4">
          <div class="d-f m-b-2 domains-row ai-c">
            <FormTags class="f-w m-r-md-2" :autocomplete="false" :blur="true" :limit="shoppingSettings.max_allowed_domains" :placeholder="$t('settings.liveshopping.add_domains')" v-bind:validation="domainRegex" :existingTags="domains" @data="setDomains($event)" />
              <Button @click="updateDomains" :disabled="state.domains === 'saving'" :class="`ml-a m-t-sm-2 m-t-md-0 very-blue ${state.domains === 'saved' ? 'success' : ''}`" :icon="state.domains === 'saving' ? 'loading mdi-spin' : ''">
                <template v-if="state.domains === 'saving'">Saving</template>
                <template v-else-if="state.domains === 'saved'">Saved</template>
                <template v-else>Save</template>
              </Button>
          </div>
          <small class="large">{{ this.$t('settings.liveshopping.add_domains_placeholder') }}.</small>
          <div>
            <small class="large">{{ shoppingSettings.max_allowed_domains - shoppingSettings.additional_domains }}/{{ shoppingSettings.max_allowed_domains }} domains used. If you need more than {{ shoppingSettings.max_allowed_domains}} domains, please contact us at <a href="mailto:sales@streamify.io" class="link blue">sales@streamify.io</a>.</small>
          </div>
        </div>
      </card-minimal>
      <template v-if="!['shopify', 'shopline'].includes(shoppingSettings.provider) && shoppingSettings.provider !== ''">
        <card-minimal :title="$t('settings.liveshopping.configure_cart')" class="m-t-4">
          <div class="p-y-2 p-x-4 d-f ai-c" style="border-bottom: 1px solid #CCCCCC;">
            <p class="f-1">{{ $t('settings.liveshopping.add') }}:</p>
            <FormDropdown :placeholder="$t('settings.liveshopping.choose_url')" id="url" :items="availableCartFunctions" @input="cartFunctions = $event.value" tabindex="0" class="ml-a tt-w f-1" />
          </div>
          <div :key="cartFunctionsKey">
            <p v-if="Object.keys(cartFunctionsEnabled).length === 0" class="p-a-4 ta-c">
              <small>{{ $t('settings.liveshopping.no_urls') }}</small>
            </p>
            <template v-for="(value, name) in cartFunctionsEnabled">
              <div class="event-row" :key="name" v-if="cartFunctions.find(url => url.value === name)">
                <header>
                  <div class="d-f ai-c">
                    <h2>{{ cartFunctions.find(url => url.value === name).string }}</h2>
                    <div class="d-f ml-a icon-button-group">
                      <FormDropdown :id="`${value}-method`" v-if="!value.only_event" :items="urlMethods.map(method => ({ ...method, selected: method.value === value.method }))" @input="updateCartFunction(name, 'method', $event.value)" />
                      <IconButton icon="close" @clicked="removeCartFunction(name)" />
                    </div>
                  </div>
                  <p v-html="value.method === 'event' ? cartFunctions.find(url => url.value === name).eventDescription : cartFunctions.find(url => url.value === name).description"></p>
                </header>
                <div class="event-row-content" v-if="value.method !== 'event'">
                  <div class="d-f f-g fd-c fd-md-r">
                    <div class="f-1" v-if="!cartFunctions.find(url => url.value === name).only_url">
                      <FormDropdown :id="`${value}-type`" :items="urlTypes.map(type => ({ ...type, selected: type.value === value.type }))" @input="updateCartFunction(name, 'type', $event.value)" v-if="value.method !== 'event'" />
                    </div>
                    <div class="f-1">
                      <FormInput :value="value.url" @input="updateCartFunction(name, 'url', $event)" class="f-w m-t-smr-2" />
                    </div>
                  </div>
                  <FormTextarea :toolbar="[]" placeholder='{ "item": "{SKU}", "quantity": "{QUANTITY}" }' v-model="cartFunctionsEnabled[name].body" :value="getCartFunctionJSONValue(name)" height="160" class="small m-t-2" v-if="value.type === 'json' && value.method !== 'event' && !cartFunctions.find(url => url.value === name).only_url" />
                </div>
              </div>
            </template>
          </div>
          <div class="p-a-4 d-f cart-button" style="border-top: 1px solid #CCCCCC;">
            <Button @click="updateCartConfigration" :disabled="state.cart === 'saving'" :class="`ml-a very-blue ${state.cart === 'saved' ? 'success' : ''}`" :icon="state.cart === 'saving' ? 'loading mdi-spin' : ''">
              <template v-if="state.cart === 'saving'">{{ $t('settings.liveshopping.saving') }}</template>
              <template v-else-if="state.cart === 'saved'">{{ $t('settings.liveshopping.saved') }}</template>
              <template v-else>{{ $t('settings.liveshopping.save') }}</template>
            </Button>
          </div>
        </card-minimal>
      </template>
    </template>
    <product-search :noAdd="true" :show="testfeed" @close="closeTestFeed()" :title="$t('settings.liveshopping.test_integration')" />
  </template>
  <template v-else>
    <div class="ta-c page-placeholder-text">
      <template v-if="!liveshoppingEnabled">
        <p>You need to active Live Shopping on your account. You can do that <a href="/settings/account" @click.prevent="$router.push('/settings/account')" class="link blue">here</a>.</p>
      </template>
      <template v-else>
        <p>An active subscription is required on your account to access the Live Shopping features.</p>
        <p><a href="/settings/plan" @click.prevent="$router.push('/settings/plan')" class="link blue">Click here to view available subscription plans</a>.</p>
      </template>
    </div>
  </template>
</div>
</template>

<script>

import ProductSearch from '@/components/Products/ProductSearch.vue';

import { getQueryParameterValue } from '@/utils';

export default {
  components: {
    ProductSearch,
  },
  computed: {
    /**
     * Return the current config in store
     * @returns {Object}
     */
    lvspConfig() {
      return this.$store.getters['Play/lvspConfig'];
    },
    /**
     * Validate feed against the provider's own validation
     * @returns {Boolean}
     */
    validateFeed() {
      const {
        provider: {
          data: provider,
        },
        providerIndex,
        // eslint-disable-next-line
        providerDataKey,
      } = this;
      let valid = true;

      if (typeof this.$options.providers[providerIndex].data === 'undefined') {
        return true;
      }

      if (Object.keys(provider).length === 0) {
        return false;
      }

      // eslint-disable-next-line
      for (let field of this.$options.providers[providerIndex].data) {
        if (field.canBeEmpty && (provider[field.write] === '' || !provider[field.write])) {
          break;
        }

        if (!field.validation) {
          break;
        }

        if (!provider[field.write]) {
          valid = false;
          break;
        }

        if (!provider[field.write].match(field.validation)) {
          valid = false;
        }
      }

      if (this.$options.providers[providerIndex].advancedFields) {
        // eslint-disable-next-line
        for (let field of this.$options.providers[providerIndex].advancedFields.data) {
          if (!field.validation) {
            break;
          }

          if (field.canBeEmpty && (provider[field.write] === '' || !provider[field.write])) {
            break;
          }

          if (!provider[field.write]) {
            valid = false;
            break;
          }

          if (!provider[field.write].match(field.validation)) {
            valid = false;
          }
        }
      }

      return valid;
    },
    /**
     * Get the current selected providers data
     * @returns {?Object}
     */
    providerData() {
      const {
        provider: {
          selected,
        },
      } = this;

      return this.$options.providers.find(p => p.id === selected);
    },
    /**
     * Return the index of the current selected provider
     * @returns {Number}
     */
    providerIndex() {
      const {
        provider: {
          selected,
        },
      } = this;

      return this.$options.providers.findIndex(p => p.id === selected);
    },
    /**
     * List of supported URLs that can be changed.
     * Is also used to activate one of the urls
     */
    cartFunctions: {
      /**
       * Get list of cart functions
       * @returns {Array}
       */
      get() {
        // Need this to keep it reactive..
        const {
          // eslint-disable-next-line
          cartFunctionsKey,
        } = this;

        return [
          // eslint-disable-next-line
          { string: this.$t('settings.liveshopping.url_conf.add_to_cart'), description: this.$t('settings.liveshopping.url_conf.add_to_cart_description'), eventDescription: this.$t('settings.liveshopping.event_conf.add_to_cart_description'), value: 'product_add_to_cart', eventValue: 'cart.add' },
          // eslint-disable-next-line
          { string: this.$t('settings.liveshopping.url_conf.change_quantity'), description: this.$t('settings.liveshopping.url_conf.change_quantity_description'), eventDescription: this.$t('settings.liveshopping.event_conf.update_in_cart_description'), value: 'product_update_quantity', eventValue: 'cart.update' },
          // eslint-disable-next-line
          { string: this.$t('settings.liveshopping.url_conf.remove_from_cart'), description: this.$t('settings.liveshopping.url_conf.remove_from_cart_description'), eventDescription: this.$t('settings.liveshopping.event_conf.remove_from_cart_description'), value: 'product_remove_from_cart', eventValue: 'cart.remove' },
          // eslint-disable-next-line
          { string: this.$t('settings.liveshopping.url_conf.checkout'), description: this.$t('settings.liveshopping.url_conf.checkout_description'), eventDescription: this.$t('settings.liveshopping.event_conf.go_to_cart_description'), only_url: true, value: 'checkout', eventValue: 'cart.checkout' },
          // eslint-disable-next-line
          { string: this.$t('settings.liveshopping.event_conf.intercept_link'), description: this.$t('settings.liveshopping.event_conf.intercept_link_description'), eventDescription: this.$t('settings.liveshopping.event_conf.intercept_link_description'), only_event: true, value: 'product.intercept-link', eventValue: 'product.intercept-link' },
        ];
      },
      /**
       * Activate cart function
       * @param {String} value
       */
      set(value) {
        this.cartFunctionsKey += 1;
        const {
          cartFunctions,
        } = this;

        const {
          only_url = false,
          only_event = false,
        } = cartFunctions.find(url => url.value === value);

        if (only_url) {
          this.cartFunctionsEnabled[value] = {
            method: 'GET',
            url: 'https://yourdomain/state',
          };
        } else if (only_event) {
          this.cartFunctionsEnabled[value] = {
            method: 'event',
            only_event: true,
          };
        } else {
          this.cartFunctionsEnabled[value] = {
            type: 'queryparams',
            url: 'https://yourdomain/?item={SKU}&quantity={QUANTITY}',
            method: 'GET',
          };
        }
      },
    },
    /**
     * Return available urls that has not already been activated
     * @returns {Array}
     */
    availableCartFunctions() {
      return this.cartFunctions.filter(func => !Object.keys(this.cartFunctionsEnabled).includes(func.value));
    },
  },
  methods: {
    updateProviderDataKey() {
      this.providerDataKey += 1;
      this.providerDataChanged = true;
    },
    /**
     * Update the cart configuration
     */
    async updateCartConfigration() {
      const {
        cartFunctionsEnabled,
      } = this;

      const payload = {
        urls: {},
        events: [],
      };

      let invalidJSON = false;
      Object.keys(cartFunctionsEnabled).forEach((key) => {
        if (cartFunctionsEnabled[key].method === 'event') {
          const eventName = this.cartFunctions.find(url => url.value === key).eventValue;
          payload.events.push(eventName);
        } else {
          payload.urls[key] = cartFunctionsEnabled[key];
          if (cartFunctionsEnabled[key].type === 'json') {
            try {
              JSON.parse(cartFunctionsEnabled[key].body);
            } catch (e) {
              invalidJSON = true;
            }
          }
        }
      });

      if (invalidJSON) {
        swal({
          title: this.$t('errors.error_occured'),
          text: this.$t('settings.liveshopping.could_not_save_invalid_json'),
          icon: 'error',
        });
        return;
      }

      this.state.cart = 'saving';
      const result = await this.$store.dispatch('Play/updateLVSPConfig', payload);

      if (result.error) {
        swal({ title: this.$t('errors.error_occured'), text: this.$t('settings.liveshopping.could_not_save'), icon: 'error' });
        this.cartState = '';
        return;
      }

      this.state.cart = 'saved';

      setTimeout(() => {
        this.state.cart = '';
      }, 1500);
    },
    /**
     * Update enabled cartfunction with new value
     * @param {String} key
     * @param {String} name
     * @param {String} value
     */
    updateCartFunction(key, name, value) {
      this.cartFunctionsEnabled[key][name] = value;
      if (name === 'method' || name === 'type') {
        this.cartFunctionsKey += 1;
      }
    },
    /**
     * Remove cart function from enabled list
     * @param {String} name
     */
    removeCartFunction(name) {
      delete this.cartFunctionsEnabled[name];
      this.cartFunctionsKey += 1;
    },
    /**
     * Parse and stringify body for cartfunction that has JSON enabled
     * @param {String} name
     * @returns {String}
     */
    getCartFunctionJSONValue(name) {
      const {
        body,
      } = this.cartFunctionsEnabled[name];

      try {
        const json = JSON.stringify(JSON.parse(body));
        return json;
      } catch (e) { /* Do nothing */ }

      return '';
    },
    /**
     * Set provider data
     */
    setProviderData() {
      const {
        providerIndex,
        provider,
        shoppingSettings: {
          metadata,
        },
      } = this;

      const oldProviderData = {
        selected: provider.selected,
      };
      const providerData = {};

      if (providerIndex >= 0) {
        if (this.$options.providers[providerIndex].data) {
          this.$options.providers[providerIndex].data.forEach((field) => {
            providerData[field.write] = metadata[field.read];
          });
        }
        if (this.$options.providers[providerIndex].advancedFields) {
          this.$options.providers[providerIndex].advancedFields.data.forEach((advField) => {
            providerData[advField.write] = metadata[advField.read];
          });
        }
      }

      this.provider = {
        ...oldProviderData,
        data: providerData,
      };

      this.providerDataChanged = false;
    },
    /**
     * Set shopping config
     */
    setShoppingConfig() {
      this.done = false;

      const {
        events = [],
        domains = [],
        urls = {},
      } = this.lvspConfig;

      if (events) {
        events.forEach((event) => {
          const ev = this.cartFunctions.find(func => func.eventValue === event);
          this.cartFunctionsEnabled[ev.value] = {
            type: 'queryparams', // Just in case we change from JS Event
            url: 'https://yourdomain/?item={SKU}&quantity={QUANTITY}', // Just in case we change from JS Event
            method: 'event',
            only_event: ev.only_event,
          };
        });
      }

      this.cartFunctionsEnabled = { ...this.cartFunctionsEnabled, ...urls };
      this.domains = domains;

      this.$nextTick(() => {
        this.done = true;
      });
    },
    /**
     * Set domains from tags-element in domain array
     * @param {Array} domains
     */
    setDomains(domains) {
      this.domains = domains;
    },
    /**
     * Update domains config
     */
    async updateDomains() {
      const {
        domains = [],
      } = this;

      this.state.domains = 'saving';

      const result = await this.$store.dispatch('Play/updateLVSPConfig', {
        domains,
      });

      if (result.error) {
        swal({
          title: this.$t('errors.error_occured'),
          text: result.error.message,
          icon: 'error',
        });
        this.state.domains = '';
        return;
      }

      this.state.domains = 'saved';
      await this.$store.dispatch('AccountManager/getShoppingSettings');

      setTimeout(() => {
        this.state.domains = '';
      }, 1500);
    },
    cancelProvider() {
      this.provider.selected = '';
      this.setProviderData();
    },
    cancelProviderUpdate() {
      this.setProviderData();
    },
    /**
     * Connect/save provider to account
     */
    async saveProvider() {
      const {
        provider: {
          data,
        },
        providerIndex,
      } = this;

      const provider = this.$options.providers[providerIndex];

      if (!provider) {
        swal({
          title: this.$t('errors.error_occured'),
          text: this.$t('errors.error_occured'),
          icon: 'error',
        });
        return;
      }

      let saveData = {};

      if (Object.keys(data).length > 1) {
        saveData = data;
      } else {
        saveData = data[Object.keys(data)[0]];
      }

      this.state.provider = 'saving';

      const result = await this.$store.dispatch(
        `Products/${provider.save.action}`,
        saveData,
      );

      if (!result) {
        swal({ title: this.$t('errors.error_occured'), text: this.$t(`errors.save_${provider.id}`), icon: 'error' });
        this.state.provider = '';
        return;
      }

      await this.$store.dispatch('AccountManager/getShoppingSettings');

      this.state.provider = '';
      this.providerDataChanged = false;

      this.setProviderData();
    },
    /**
     * Disconnect account from shopping provider
     */
    async disconnectProvider() {
      const willDisconnect = await swal({
        title: this.$t('common.are_you_sure'),
        text: 'This will disconnect you from this provider.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      });

      if (!willDisconnect) {
        return;
      }

      await this.$store.dispatch('AccountManager/disconnectProvider');
      await this.$store.dispatch('AccountManager/getShoppingSettings');
      this.$nextTick(() => {
        this.provider.selected = '';
        this.setProviderData();
      });
    },
    /**
     * Refresh provider feed
     */
    async refreshProvider() {
      if (this.shoppingSettings.metadata.status === 'feed_parsing') {
        return;
      }

      const {
        providerIndex,
      } = this;

      const provider = this.$options.providers[providerIndex];

      this.state.refresh = 'refreshing';

      const ok = await this.$store.dispatch(`Products/${provider.refresh.action}`);
      if (!ok) {
        swal({
          title: this.$t('errors.error_occured'),
          text: this.$t(`errors.refresh_${provider.id}_feed`),
          icon: 'error',
        });
        this.state.refresh = '';
        return;
      }

      this.state.refresh = 'refreshed';
      setTimeout(() => {
        this.state.refresh = '';
      }, 2000);
    },
    /**
     * Close the test feed and clear products
     */
    closeTestFeed() {
      this.testfeed = false;
      this.$nextTick(() => {
        this.$store.dispatch('Products/clearSearchProducts');
      });
    },
  },
  watch: {
    /**
     * Listen for changes on assumed computed value
     */
    assumed() {
      this.$store.dispatch('AccountManager/getShoppingSettings');
    },
    /**
     * Listen for changes in shoppingsettings object
     */
    shoppingSettings: {
      immediate: true,
      async handler(settings) {
        if (settings !== null) {
          this.provider.selected = settings.provider || '';
          await this.$store.dispatch('Play/getLVSPConfig');
          this.setShoppingConfig();
          this.providerKey += 1;
        }
      },
    },
    /**
     * Listen for changes on provider.selected value
     */
    'provider.selected': {
      immediate: true,
      handler() {
        this.setProviderData();
      },
    },
  },
  data() {
    return {
      cartFunctionsKey: 0,
      cartFunctionsEnabled: {},
      domainsKey: 0,
      urlMethods: [{ value: 'event', string: 'JS Event' }, { value: 'GET', string: 'GET' }, { value: 'POST', string: 'POST' }, { value: 'PATCH', string: 'UPDATE' }, { value: 'PUT', string: 'PUT' }, { value: 'DELETE', string: 'DELETE' }],
      urlTypes: [{ value: 'queryparams', string: 'Query parameters' }, { value: 'json', string: 'JSON' }],
      cartTypes: [{ value: 'events', string: 'Events' }, { value: 'urls', string: 'URLs' }],
      state: {
        provider: '',
        cart: '',
        domains: '',
        refresh: '',
      },
      providerKey: 0,
      providerDataKey: 0,
      providerDataChanged: false,
      provider: {
        selected: '',
        data: {},
      },
      showAdvanced: false,
      domains: [],
      testfeed: false,
      // eslint-disable-next-line
      domainRegex: /^(?:(?:(?:[a-zA-z\-]+)\:\/{1,3})?(?:[a-zA-Z0-9])(?:[a-zA-Z0-9\-\.]){1,61}(?:\.[a-zA-Z]{2,})+|\[(?:(?:(?:[a-fA-F0-9]){1,4})(?::(?:[a-fA-F0-9]){1,4}){7}|::1|::)\]|(?:(?:[0-9]{1,3})(?:\.[0-9]{1,3}){3}))(?:\:[0-9]{1,5})?$/i,
      done: false,
    };
  },
  mounted() {
    const shop = getQueryParameterValue('shop');
    if (shop !== '') {
      this.provider.selected = 'shopify';
      this.saveProvider();
    }
  },
  providers: [
    {
      id: 'google-merchant',
      name: 'Google Merchant',
      buttonText: 'submit', // will match again i18n settings.submit
      buttonFlightText: 'submitting',
      saveable: true,
      refresh: {
        action: 'refreshGoogleMerchantFeed',
      },
      save: {
        action: 'saveGoogleMerchantFeed',
      },
      data: [
        {
          read: 'url',
          disable: true,
          write: 'url',
          class: 'f-w',
          placeholder: 'feed',
          label: 'url_label',
          validation: /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
        },
      ],
    },
    {
      id: 'link',
      name: 'Product links',
      buttonText: 'submit', // will match again i18n settings.connect
      buttonFlightText: 'submitting',
      saveable: true,
      manual: true,
      save: {
        action: 'saveProductLinks',
      },
    },
    {
      id: 'shopify',
      name: 'Shopify',
      buttonText: 'connect', // will match again i18n settings.connect
      buttonFlightText: 'connecting',
      saveable: true,
      save: {
        action: 'saveShopifyFeed',
      },
      data: [
        {
          read: 'store',
          disable: true,
          write: 'store',
          class: 'f-w',
          placeholder: 'store',
          label: 'store_label',
          validation: /^(.*)$/,
        },
      ],
    },
    {
      id: 'shopify-app',
      name: 'Shopify',
      buttonText: 'connect', // will match again i18n settings.connect
      buttonFlightText: 'connecting',
      saveable: false,
      data: [
        {
          read: 'store',
          disable: true,
          write: 'store',
          class: 'f-w',
          label: 'store_label',
          placeholder: 'store',
        },
      ],
    },
    {
      id: 'shopline',
      name: 'Shopline',
      buttonText: 'connect',
      buttonFlightText: 'connecting',
      saveable: true,
      data: [
        {
          read: 'store',
          disable: true,
          write: 'store',
          class: 'f-w',
          label: 'store_label',
          placeholder: 'store',
        },
      ],
    },
    {
      id: 'geins',
      name: 'Geins',
      buttonText: 'submit',
      buttonFlightText: 'submitting',
      saveable: true,
      save: {
        action: 'saveGeins',
      },
      data: [
        {
          read: 'apikey',
          write: 'apikey',
          class: 'f-w',
          label: 'apikey_label',
          placeholder: 'apikey',
          validation: /^(.*)$/,
        },
        {
          read: 'image_host_domain',
          write: 'image_host_domain',
          class: 'f-1',
          label: 'image_host_domain_label',
          placeholder: 'image_host_domain',
          validation: /^(https?:\/\/)?((?!http[s]?:\/\/)[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/i,
        },
        {
          read: 'schema_image_size',
          write: 'schema_image_size',
          class: 'f-1',
          label: 'schema_image_size_label',
          placeholder: 'schema_image_size',
          tooltip: 'Find your correct size in the Media section in Merchant Center.',
          canBeEmpty: true,
          validation: /^(.*)$/,
        },
        {
          read: 'product_sku_label',
          write: 'product_sku_label',
          class: 'f-1',
          label: 'product_sku_label_label',
          placeholder: 'product_sku_label',
          canBeEmpty: true,
          validation: /^(.*)$/,
        },
      ],
      advancedFields: {
        data: [
          {
            read: 'currency',
            write: 'currency',
            class: 'f-1',
            label: 'currency_label',
            placeholder: 'currency',
            canBeEmpty: true,
            validation: /^(.*)$/,
          },
          {
            read: 'market_id',
            write: 'market_id',
            class: 'f-1',
            label: 'market_id_label',
            placeholder: 'market_id',
            canBeEmpty: true,
            validation: /^(.*)$/,
          },
          {
            read: 'url',
            write: 'url',
            class: 'f-1',
            label: 'url_label',
            placeholder: 'url',
            canBeEmpty: true,
            validation: /^(.*)$/,
          },
        ],
      },
    },
    {
      id: 'centra',
      name: 'Centra',
      buttonText: 'submit', // will match again i18n settings.connect
      buttonFlightText: 'submitting',
      saveable: true,
      save: {
        action: 'saveCentra',
      },
      data: [
        {
          read: 'url',
          disable: true,
          write: 'url',
          class: 'f-w',
          label: 'url_label',
          placeholder: 'url',
          validation: /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
        },
      ],
      advancedFields: {
        description: 'Yeah',
        data: [
          {
            read: 'origin',
            disable: false,
            write: 'origin',
            class: 'f-2',
            placeholder: 'origin_url',
            tooltip: true,
            label: 'origin_url',
            canBeEmpty: true,
            // eslint-disable-next-line
            validation: /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
          },
        ],
      },
    },
    {
      id: 'magento',
      name: 'Magento',
      buttonText: 'submit',
      buttonFlightText: 'submitting',
      saveable: true,
      hiddenForOutsiders: true,
      save: {
        action: 'saveMagentoFeed',
      },
      data: [
        {
          read: 'url',
          disable: true,
          write: 'url',
          class: 'f-2',
          label: 'url_label',
          placeholder: 'url',
          validation: /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
        },
        {
          read: 'token',
          disable: false,
          write: 'token',
          class: 'f-1',
          label: 'token_label',
          placeholder: 'token',
          validation: /^(.*)$/,
        },
      ],
    },
  ],
};
</script>

<style lang="scss">
.event-row {
  .icon-button-group {
    .icon-button {
      height: auto;
      margin-left: 5px;
      .icon-button-inner {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.advanced {
  .input.has-tooltip {
    .input-inner {
      padding-right: 0;
      input {
        padding-right: 32px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.liveshopping-settings {
  &.centerize {
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
  }
}
.integrations-title {
  -ms-flex-align: center;
  align-items: center;
  color: #1F394A;
  display: -ms-flexbox;
  display: flex;
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.cart-button {
  @media (max-width: 600px) {
    .button {
      margin-left: unset;
      width: 100%;
    }
  }
}

.domains-row, .provider-row {
  align-items: flex-start;

  @media (max-width: 600px) {
    .inputs > div {
      flex-direction: column;
      & > * {
        margin-left: 0;
        &:not(:first-child) {
          margin-top: 10px;
        }
      }
    }
  }

  .buttons {
    margin-top: 10px;
  }

  @media (max-width: 600px) {
    .buttons {
      width: 100%;
      & > div {
        align-items: stretch;
        flex-direction: column;
        .button {
          margin-right: 0;
          margin-left: 0;
          &:not(:first-child) {
            margin-top: 10px;
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    flex-direction: column;
    .buttons {
      margin-top: 10px;
      margin-left: auto;

      & > label {
        display: none;
      }
    }
  }

  @media (min-width: 950px) {
    .buttons {
      // margin-left: 10px;
      .button {
        white-space: nowrap;
      }
    }
  }
}

.event-row {
  border-bottom: 1px solid #e0e0e0;
  .event-row-content {
    border-top: 1px solid #E7E9EC;
    padding: 20px;
  }
  header {
    background-color: white;
    position: relative;
    padding: 20px;

    i {
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    h2 {
      font-size: 1rem;
      line-height: 1.5;
    }
    p {
      color: #636363;
      line-height: 1.5;
    }
  }

  @media (max-width: 600px) {
    p {
      margin-top: 10px;
    }
  }

  &:last-child {
    border-bottom: 0;
  }

  .dropdown-row {
    .dropdown {
      border-radius: 0;
      float: left;
      width: 50%;

      .inner {
        border-radius: 0;
      }

      &:first-child {
        border-radius: 5px 0 0 0;
        .inner {
          border-radius: 5px 0 0 0;
        }
      }

      &:last-child {
        border-radius: 0 5px 0 0;
        .inner {
          border-radius: 0 5px 0 0;
        }
      }
    }

    &:after {
      content: "";
      clear: both;
      display: table;
    }
  }

  .tui-editor-defaultUI {
    border-radius: 0 0 5px 5px;
    border-top: 0;

    .te-toolbar-section {
      display: none;
    }
  }

  .url-row {
    &.no-borders {
      .input {
        border-radius: 0;
        border-top: 0;
        border-bottom: 0;
      }

      .input-wrapper {
        border-radius: 0;
      }

      .input-inner {
        border-radius: 0;
      }

      input {
        border-radius: 0;
      }
    }

    &.no-top-borders {
      .input {
        border-radius: 0 0 5px 5px;
        border-top: 0;
      }

      .input-wrapper {
        border-radius: 0 0 5px 5px;
      }

      .input-inner {
        border-radius: 0 0 4px 4px;
      }

      input {
        border-radius: 0;
      }
    }
  }
}

.providers {
  display: flex;
  flex-wrap: wrap;

  .provider {
    margin: 0 0 20px;
    width: 100%;

    .provider-logo {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 120px;
      width: 100%;
    }

    .provider-description {
      display: none;

      i {
        font-size: 1.5rem;
        margin-right: 0.5rem;
      }
    }

    &.provider--active {
      margin-bottom: 0;

      .provider-logo {
        height: auto;
        align-items: flex-start;
        padding: 20px 20px 10px;
      }

      .provider-description {
        align-items: center;
        display: flex;
        padding: 10px 20px 20px;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  &.providers--full {
    .provider {
      width: 100%;
      &:not(.provider--active) {
        display: none;
      }
    }
  }

  @media (min-width: 1024px) {
    margin: 0 -10px;

    .provider {
      margin: 0 10px 20px;
      width: calc(50% - 20px);
    }
  }
  @media (min-width: 1500px) {
    .provider {
      width: calc(33.333% - 20px);
    }
  }
}
</style>
